import React from "react";
const SvgHidden = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      d="M7.1 17.1C3.8 15.3 2 12 2 12s3.4-6.3 9.7-6.3c1.7 0 3.2.5 4.5 1.1m2 1.7c2 1.7 3 3.7 3 3.7s-3.3 6.4-9.6 6.4l-2.1-.3m6-6.8v.5c0 2-1.7 3.8-3.8 3.8m-2.5-1a3.8 3.8 0 015-5.6M18.8 4L4.5 20"
    />
  </svg>
);
export default SvgHidden;
